<ng-container *ngIf="regepJurisdictionForm">
  <form [formGroup]="regepJurisdictionForm" class="ui-g location-data-container component-container">
    <div class="ui-g-12 top-margin location-installation-section">
      <div class="ui-g-6 ui-xl-6 ui-lg-6 ui-md-12 ui-sm-12 ui-xs-12 field-rows field-label">
        <p-checkbox
          formControlName="totalFeedInPowerIsAboveCentralGridThreshold"
          binary="true"
          name="totalFeedInPowerIsAboveCentralGridThreshold"
          label="{{ 'regep.total-feed-in-power' | translate }}"></p-checkbox>
      </div>

      <div
        *ngIf="regepJurisdictionForm.get('gridCompAssessmentOrderNumber')"
        class="ui-g-6 ui-xl-6 ui-lg-6 ui-md-12 ui-sm-12 ui-xs-12 field-rows">
        <label class="field-label required">{{ 'regep.grid-comp-assessment-order-number' | translate }}</label>
        <input
          type="text"
          pInputText
          formControlName="gridCompAssessmentOrderNumber"
          name="gridCompAssessmentOrderNumber"
          [required]="true" />
      </div>
    </div>
  </form>
</ng-container>
